export const FETCH_EWS_COUNTERPARTIES_REQUEST = 'FETCH_EWS_COUNTERPARTIES_REQUEST';
export const FETCH_EWS_COUNTERPARTIES_RESPONSE = 'FETCH_EWS_COUNTERPARTIES_RESPONSE';

export const fetchEwsCounterpartiesRequest = (data) => {
    return {
        type: FETCH_EWS_COUNTERPARTIES_REQUEST,
        data
    }
}
export const fetchEwsCounterpartiesResponse = (data) => {
    return {
        type: FETCH_EWS_COUNTERPARTIES_RESPONSE,
        data
    }
}

export const FETCH_FILTERED_EWS_COUNTERPARTIES_REQUEST = 'FETCH_FILTERED_EWS_COUNTERPARTIES_REQUEST';
export const FETCH_FILTERED_EWS_COUNTERPARTIES_RESPONSE = 'FETCH_FILTERED_EWS_COUNTERPARTIES_RESPONSE';

export const fetchFilteredEwsCounterpartiesRequest = (data) => {
    return {
        type: FETCH_FILTERED_EWS_COUNTERPARTIES_REQUEST,
        data
    }
}
export const fetchFilteredEwsCounterpartiesResponse = (data) => {
    return {
        type: FETCH_FILTERED_EWS_COUNTERPARTIES_RESPONSE,
        data
    }
}

export const OPT_IN_FOR_EWS_REQUEST = 'OPT_IN_FOR_EWS_REQUEST';
export const OPT_IN_FOR_EWS_RESPONSE = 'OPT_IN_FOR_EWS_RESPONSE';

export const optInForEwsRequest = (data) => {
    return {
        type: OPT_IN_FOR_EWS_REQUEST,
        data
    }
}
export const optInForEwsResponse = (data) => {
    return {
        type: OPT_IN_FOR_EWS_RESPONSE,
        data
    }
}

export const FETCH_EWS_PLAN_LIST_REQUEST = 'FETCH_EWS_PLAN_LIST_REQUEST';
export const FETCH_EWS_PLAN_LIST_RESPONSE = 'FETCH_EWS_PLAN_LIST_RESPONSE';

export const ewsPlanListRequest = (data) => {
    return {
        type: FETCH_EWS_PLAN_LIST_REQUEST,
        data
    }
}
export const ewsPlanListResponse = (data) => {
    return {
        type: FETCH_EWS_PLAN_LIST_RESPONSE,
        data
    }
}

export const FETCH_EWS_PLAN_REQUEST = 'FETCH_EWS_PLAN_REQUEST';
export const FETCH_EWS_PLAN_RESPONSE = 'FETCH_EWS_PLAN_RESPONSE';

export const ewsPlanRequest = (data) => {
    return {
        type: FETCH_EWS_PLAN_REQUEST,
        data
    }
}
export const ewsPlanResponse = (data) => {
    return {
        type: FETCH_EWS_PLAN_RESPONSE,
        data
    }
}

export const ADD_EWS_PLAN_REQUEST = 'ADD_EWS_PLAN_REQUEST';
export const ADD_EWS_PLAN_RESPONSE = 'ADD_EWS_PLAN_RESPONSE';

export const addEwsPlanRequest = (data) => {
    return {
        type: ADD_EWS_PLAN_REQUEST,
        data
    }
}
export const addEwsPlanResponse = (data) => {
    return {
        type: ADD_EWS_PLAN_RESPONSE,
        data
    }
}

export const COUNTERPARTY_UPLOAD_TEMPLATE_REQUEST = 'COUNTERPARTY_UPLOAD_TEMPLATE_REQUEST';
export const COUNTERPARTY_UPLOAD_TEMPLATE_RESPONSE = 'COUNTERPARTY_UPLOAD_TEMPLATE_RESPONSE';

export const counterpartyUploadTemplateRequest = (data) => {
    return {
        type: COUNTERPARTY_UPLOAD_TEMPLATE_REQUEST,
        data
    }
}
export const counterpartyUploadTemplateResponse = (data) => {
    return {
        type: COUNTERPARTY_UPLOAD_TEMPLATE_RESPONSE,
        data
    }
}

export const COUNTERPARTY_UPLOAD_REQUEST = 'COUNTERPARTY_UPLOAD_REQUEST';
export const COUNTERPARTY_UPLOAD_RESPONSE = 'COUNTERPARTY_UPLOAD_RESPONSE';

export const counterpartyUploadRequest = (data) => {
    return {
        type: COUNTERPARTY_UPLOAD_REQUEST,
        data
    }
}
export const counterpartyUploadResponse = (data) => {
    return {
        type: COUNTERPARTY_UPLOAD_RESPONSE,
        data
    }
}

export const UPDATE_PLAN_IN_MAPPING_REQUEST = 'UPDATE_PLAN_IN_MAPPING_REQUEST';
export const UPDATE_PLAN_IN_MAPPING_RESPONSE = 'UPDATE_PLAN_IN_MAPPING_RESPONSE';

export const updatePlanInMappingRequest = (data) => {
    return {
        type: UPDATE_PLAN_IN_MAPPING_REQUEST,
        data
    }
}
export const updatePlanInMappingResponse = (data) => {
    return {
        type: UPDATE_PLAN_IN_MAPPING_RESPONSE,
        data
    }
}

export const CRAWLER_STATUS_REPORT_REQUEST = 'CRAWLER_STATUS_REPORT_REQUEST';
export const CRAWLER_STATUS_REPORT_RESPONSE = 'CRAWLER_STATUS_REPORT_RESPONSE';

export const fetchCrawlerStatusReportRequest = (data) => {
    return {
        type: CRAWLER_STATUS_REPORT_REQUEST,
        data
    }
}
export const fetchCrawlerStatusReportResponse = (data) => {
    return {
        type: CRAWLER_STATUS_REPORT_RESPONSE,
        data
    }
}

export const REINITIATE_CRAWLERS_REQUEST = 'REINITIATE_CRAWLERS_REQUEST';
export const REINITIATE_CRAWLERS_RESPONSE = 'REINITIATE_CRAWLERS_RESPONSE';

export const reinitiateFailedCrawlersRequest = (data) => {
    return {
        type: REINITIATE_CRAWLERS_REQUEST,
        data
    }
}
export const reinitiateFailedCrawlersResponse = (data) => {
    return {
        type: REINITIATE_CRAWLERS_RESPONSE,
        data
    }
}

export const GET_DAY_OF_MONTH_REQUEST = 'GET_DAY_OF_MONTH_REQUEST';
export const GET_DAY_OF_MONTH_RESPONSE = 'GET_DAY_OF_MONTH_RESPONSE';

export const getDayOfMonthRequest = (data) => {
    return {
        type: GET_DAY_OF_MONTH_REQUEST,
        data
    }
}
export const getDayOfMonthResponse = (data) => {
    return {
        type: GET_DAY_OF_MONTH_RESPONSE,
        data
    }
}
export const UPDATE_DAY_OF_MONTH_REQUEST = 'UPDATE_DAY_OF_MONTH_REQUEST';
export const UPDATE_DAY_OF_MONTH_RESPONSE = 'UPDATE_DAY_OF_MONTH_RESPONSE';

export const updateDayOfMonthRequest = (data) => {
    return {
        type: UPDATE_DAY_OF_MONTH_REQUEST,
        data
    }
}
export const updateDayOfMonthResponse = (data) => {
    return {
        type: UPDATE_DAY_OF_MONTH_RESPONSE,
        data
    }
}

export const RUN_EWS_REQUEST = 'RUN_EWS_REQUEST';
export const RUN_EWS_RESPONSE = 'RUN_EWS_RESPONSE';

export const runEWSRequest = () => {
    return {
        type: RUN_EWS_REQUEST,
    }
}
export const runEWSResponse = (data) => {
    return {
        type: RUN_EWS_RESPONSE,
        data
    }
}

export const EWS_DATA_UPLOAD_TEMPLATE_REQUEST = 'EWS_DATA_UPLOAD_TEMPLATE_REQUEST';
export const EWS_DATA_UPLOAD_TEMPLATE_RESPONSE = 'EWS_DATA_UPLOAD_TEMPLATE_RESPONSE';

export const ewsReportDataUploadTemplateRequest = () => {
    return {
        type: EWS_DATA_UPLOAD_TEMPLATE_REQUEST,
    }
}
export const ewsReportDataUploadTemplateResponse = (data) => {
    return {
        type: EWS_DATA_UPLOAD_TEMPLATE_RESPONSE,
        data
    }
}

export const EWS_DATA_UPLOAD_REQUEST = 'EWS_DATA_UPLOAD_REQUEST';
export const EWS_DATA_UPLOAD_RESPONSE = 'EWS_DATA_UPLOAD_RESPONSE';

export const ewsReportDataUploadRequest = (data) => {
    return {
        type: EWS_DATA_UPLOAD_REQUEST,
        data
    }
}
export const ewsReportDataUploadResponse = (data) => {
    return {
        type: EWS_DATA_UPLOAD_RESPONSE,
        data
    }
}

export const CORPORATE_COUNTERPARTY_LIST_REQUEST = 'CORPORATE_COUNTERPARTY_LIST_REQUEST';
export const CORPORATE_COUNTERPARTY_LIST_RESPONSE = 'CORPORATE_COUNTERPARTY_LIST_RESPONSE';

export const corporateCounterpartyListRequest = (data) => {
    return {
        type: CORPORATE_COUNTERPARTY_LIST_REQUEST,
        data
    }
}
export const corporateCounterpartyListResponse = (data) => {
    return {
        type: CORPORATE_COUNTERPARTY_LIST_RESPONSE,
        data
    }
}

export const EWS_BULK_OPTIN_REQUEST = 'EWS_BULK_OPTIN_REQUEST';
export const EWS_BULK_OPTIN_RESPONSE = 'EWS_BULK_OPTIN_RESPONSE';

export const ewsBulkOptinRequest = (data) => {
    return {
        type: EWS_BULK_OPTIN_REQUEST,
        data
    }
}
export const ewsBulkOptinResponse = (data) => {
    return {
        type: EWS_BULK_OPTIN_RESPONSE,
        data
    }
}

export const BULK_CRAWLER_STATUS_REQUEST = 'BULK_CRAWLER_STATUS_REQUEST';
export const BULK_CRAWLER_STATUS_RESPONSE = 'BULK_CRAWLER_STATUS_RESPONSE';

export const bulkCrawlerStatusRequest = (data) => {
    return {
        type: BULK_CRAWLER_STATUS_REQUEST,
        data
    }
}
export const bulkCrawlerStatusResponse = (data) => {
    return {
        type: BULK_CRAWLER_STATUS_RESPONSE,
        data
    }
}

export const CREATE_EWS_PUBLISH_REQUEST = 'CREATE_EWS_PUBLISH_REQUEST';
export const CREATE_EWS_PUBLISH_RESPONSE = 'CREATE_EWS_PUBLISH_RESPONSE';

export const createEWSPublishRequest = (data) => {
    return {
        type: CREATE_EWS_PUBLISH_REQUEST,
        data
    }
}
export const createEWSPublishResponse = (data) => {
    return {
        type: CREATE_EWS_PUBLISH_RESPONSE,
        data
    }
}

export const PUBLISH_UNPUBLISH_EWS_REPORT_REQUEST = 'PUBLISH_UNPUBLISH_EWS_REPORT_REQUEST';
export const PUBLISH_UNPUBLISH_EWS_REPORT_RESPONSE = 'PUBLISH_UNPUBLISH_EWS_REPORT_RESPONSE';

export const publishUnpublishEWSReportRequest = (data) => {
    return {
        type: PUBLISH_UNPUBLISH_EWS_REPORT_REQUEST,
        data
    }
}
export const publishUnpublishEWSReportResponse = (data) => {
    return {
        type: PUBLISH_UNPUBLISH_EWS_REPORT_RESPONSE,
        data
    }
}

export const GET_PUBLISH_DATA_REQUEST = 'GET_PUBLISH_DATA_REQUEST';
export const GET_PUBLISH_DATA_RESPONSE = 'GET_PUBLISH_DATA_RESPONSE';

export const getPublishDataRequest = (data) => {
    return {
        type: GET_PUBLISH_DATA_REQUEST,
        data
    }
}
export const getPublishDataResponse = (data) => {
    return {
        type: GET_PUBLISH_DATA_RESPONSE,
        data
    }
}

export const GET_PUBLISH_LIST_REQUEST = "GET_PUBLISH_LIST_REQUEST";
export const GET_PUBLISH_LIST_RESPONSE = "GET_PUBLISH_LIST_RESPONSE";

export const getPublishListRequest = (data) => {
    return {
        type : GET_PUBLISH_LIST_REQUEST,
        data
    }
}

export const getPublishListResponse = (data) => {
    return {
        type : GET_PUBLISH_LIST_RESPONSE,
        data
    }
}

export const DOWNLOAD_EWS_REPORT_BY_DATE_REQUEST = "DOWNLOAD_EWS_REPORT_BY_DATE_REQUEST";
export const DOWNLOAD_EWS_REPORT_BY_DATE_RESPONSE = "DOWNLOAD_EWS_REPORT_BY_DATE_RESPONSE";

export const downloadEWSReportByDateRequest = (data) => {
    return {
        type : DOWNLOAD_EWS_REPORT_BY_DATE_REQUEST,
        data
    }
}

export const downloadEWSReportByDateResponse = (data) => {
    return {
        type : DOWNLOAD_EWS_REPORT_BY_DATE_RESPONSE,
        data
    }
}

export const SEND_EWS_REPORT_INDIVIDUAL_MAIL_REQUEST = "SEND_EWS_REPORT_INDIVIDUAL_MAIL_REQUEST";
export const SEND_EWS_REPORT_INDIVIDUAL_MAIL_RESPONSE = "SEND_EWS_REPORT_INDIVIDUAL_MAIL_RESPONSE";

export const sendEWSIndividualMailRequest = (data) => {
    return {
        type : SEND_EWS_REPORT_INDIVIDUAL_MAIL_REQUEST,
        data
    }
}

export const sendEWSIndividualMailResponse = (data) => {
    return {
        type : DOWNLOAD_EWS_REPORT_BY_DATE_RESPONSE,
        data
    }
}

export const DELETE_PUBLISH_REQUEST = "DELETE_PUBLISH_REQUEST";
export const DELETE_PUBLISH_RESPONSE = "DELETE_PUBLISH_RESPONSE";

export const deletePublishRequest = (data) => {
    return {
        type : DELETE_PUBLISH_REQUEST,
        data
    }
}

export const deletePublishResponse = (data) => {
    return {
        type : DELETE_PUBLISH_RESPONSE,
        data
    }
}

export const EWS_REPORT_FINANCIAL_REQUEST = 'EWS_REPORT_FINANCIAL_REQUEST';
export const EWS_REPORT_FINANCIAL_RESPONSE = 'EWS_REPORT_FINANCIAL_RESPONSE';

export const ewsReportWithFinancialRequest = (data) => {
    return {
        type: EWS_REPORT_FINANCIAL_REQUEST,
        data
    }
}
export const ewsReportWithFinancialResponse = (data) => {
    return {
        type: EWS_REPORT_FINANCIAL_RESPONSE,
        data
    }
}

export const EWS_TODO_OPTIN_SCHEDULER_REQUEST = 'EWS_TODO_OPTIN_SCHEDULER_REQUEST';
export const EWS_TODO_OPTIN_SCHEDULER_RESPONSE = 'EWS_TODO_OPTIN_SCHEDULER_RESPONSE';

export const ewsTodoOptinSchedulerRequest = (data) => {
    return {
        type: EWS_TODO_OPTIN_SCHEDULER_REQUEST,
        data
    }
}

export const ewsTodoOptinSchedulerResponse = (data) => {
    return {
        type: EWS_TODO_OPTIN_SCHEDULER_RESPONSE,
        data
    }
}

export const EWS_OPTED_OUT_REPORT_REQUEST = 'EWS_OPTED_OUT_REPORT_REQUEST';
export const EWS_OPTED_OUT_REPORT_RESPOSNE = 'EWS_OPTED_OUT_REPORT_RESPOSNE';

export const ewsOptedOutReportRequest = (data) => {
    return {
        type: EWS_OPTED_OUT_REPORT_REQUEST,
        data
    }
}

export const ewsOptedOutReportResponse = (data) => {
    return {
        type: EWS_OPTED_OUT_REPORT_RESPOSNE,
        data
    }
}

export const EWS_CORPORATE_NAMES_DOWNLOAD_REQUEST = 'EWS_CORPORATE_NAMES_DOWNLOAD_REQUEST';
export const EWS_CORPORATE_NAMES_DOWNLOAD_RESPOSNE = 'EWS_CORPORATE_NAMES_DOWNLOAD_RESPOSNE';

export const ewsCorporateNamesDownloadRequest = (data) => {
    return {
        type: EWS_CORPORATE_NAMES_DOWNLOAD_REQUEST,
        data
    }
}

export const ewsCorporateNamesDownloadResponse = (data) => {
    return {
        type: EWS_CORPORATE_NAMES_DOWNLOAD_RESPOSNE,
        data
    }
}

export const EWS_CORPORATE_NAMES_UPLOAD_REQUEST = 'EWS_CORPORATE_NAMES_UPLOAD_REQUEST';
export const EWS_CORPORATE_NAMES_UPLOAD_RESPOSNE = 'EWS_CORPORATE_NAMES_UPLOAD_RESPOSNE';

export const ewsCorporateNamesUploadRequest = (data) => {
    return {
        type: EWS_CORPORATE_NAMES_UPLOAD_REQUEST,
        data
    }
}

export const ewsCorporateNamesUploadResponse = (data) => {
    return {
        type: EWS_CORPORATE_NAMES_UPLOAD_RESPOSNE,
        data
    }
}